import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet-async'
import { Pagination, Spin } from 'antd'

import PageTitle from '../../components/ui/title/PageTitle'
import DefaultCard from '../../components/ui/cards/DefaultCard'

import axiosRequest from '../../helpers/axios-request.helper'
import axiosErrorHelper from '../../helpers/axios-error.helper'
import convertJsonToUrlParams from '../../helpers/convert-json-to-url-params'
import Table from '../../components/ui/table/Table'

const mapStateToProps = ({ users }) => ({ users })

const NewsletterSubscribersPage = () => {
  const [loading, setLoading] = useState(true)
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 24,
    onlyWholesalers: 'all',
  })
  const [data, setData] = useState({ data: [], total: 0 })

  const getData = () => {
    setLoading(true)
    axiosRequest(
      `api/v1/newsletters-admin${convertJsonToUrlParams(filters)}`,
      'get',
      null,
      true,
    )
      .then((res) => {
        setData({ data: res.data.data.data.data, total: res.data.data.total })
      })
      .catch((e) => {
        axiosErrorHelper(e)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  return (
    <>
      <Helmet title="Newsletter Subscribers" />
      <PageTitle
        title={`Newsletter Subscribers (${data.total || 0})`}
        breadcrumbs={[
          { path: '/', name: 'Dashboard' },
          { path: '/crm/leads', name: 'CRM' },
          {
            path: '/crm/newsletter-subscribers',
            name: 'Newsletter Subscribers',
          },
        ]}
      />
      <Spin spinning={loading}>
        <DefaultCard>
          <Table
            columns={[
              {
                key: 'fullName',
                name: 'Full Name',
                headClassName: null,
                itemClassName: null,
                render: (item) => (
                  <>
                    <p className="mb-0">
                      <strong>{item.fullName || '—'}</strong>
                    </p>
                  </>
                ),
              },
              {
                key: 'email',
                name: 'Email',
                headClassName: null,
                itemClassName: null,
                render: (item) => (
                  <>
                    <p className="mb-0">
                      <strong>{item.email || '—'}</strong>
                    </p>
                  </>
                ),
              },
              {
                key: 'phone',
                name: 'Phone',
                headClassName: null,
                itemClassName: null,
                render: (item) => (
                  <>
                    <p className="mb-0">
                      <strong>{item.phone || '—'}</strong>
                    </p>
                  </>
                ),
              },
              {
                key: 'interests',
                name: 'Interests',
                headClassName: null,
                itemClassName: null,
                render: (item) => (
                  <div>
                    {item.get_locations && item.get_locations.length > 0
                      ? item.get_locations.map((l, index) => (
                          <span key={`location_${l.id}`}>
                            <strong>
                              {l.city ? `${l.city}, ` : ''}
                              {l.county ? `${l.county}, ` : ''}
                              {l.state ? `${l.state}` : ''}{' '}
                            </strong>
                            {index + 1 === item.get_locations.length
                              ? ''
                              : ' | '}
                          </span>
                        ))
                      : null}
                  </div>
                ),
              },
            ]}
            data={data.data}
          />
          {filters.perPage < data.total && (
            <Pagination
              className="mt-4"
              size="small"
              current={filters.page}
              pageSize={filters.perPage}
              total={data.total}
              showSizeChanger={false}
              onChange={(page) => setFilters({ ...filters, page })}
            />
          )}
        </DefaultCard>
      </Spin>
    </>
  )
}

export default withRouter(connect(mapStateToProps)(NewsletterSubscribersPage))
